import { useContext } from 'react';

import { FunnelEntryPointContext } from './funnel_entry_point_context';

export const useFunnelEntryPointContext = () => {
  const value = useContext(FunnelEntryPointContext);
  if (!value) throw new Error('Missing FunnelEntryPoint provider');
  return value;
};
